import React from 'react';
import { BellIcon, CheckCircle2Icon, FileTextIcon, MailIcon, MessageSquareIcon, TrendingUpIcon } from 'lucide-react';
import { LoanShell } from '../components/loan/LoanShell';
import { activity, notificationPatterns } from '../data/loanStatus';
import { useTokens } from '../hooks/useTokens';
const activityIcon: Record<string, React.ReactNode> = {
  status: <TrendingUpIcon className="h-4 w-4" data-id="element-1090" data-mp="3fgoso10wv32p" />,
  request: <FileTextIcon className="h-4 w-4" data-id="element-1091" data-mp="3ajyb199gjzf6" />,
  accepted: <CheckCircle2Icon className="h-4 w-4" data-id="element-1092" data-mp="3ahlpkm4hr6xd" />
};
export function Updates() {
  const {
    fill
  } = useTokens();
  return <LoanShell data-id="element-1093" data-mp="30liid1us8i3k">
      <main className="mx-auto grid max-w-6xl gap-12 px-5 pb-16 pt-8 md:px-8 md:pt-12 lg:grid-cols-[1fr_380px]" data-id="element-1094" data-mp="30kz35swio7t8">
        <section aria-labelledby="updates-title" data-id="element-1095" data-mp="2wkyqacp2g4oa">
          <h1 id="updates-title" className="text-[28px] font-semibold tracking-[-0.03em] text-ink-900 md:text-[36px]" data-id="element-1096" data-mp="2wm9ugdmfbefx">
            Updates
          </h1>
          <p className="mt-1 text-ink-500" data-id="element-1097" data-mp="utljfi3jfmpl">Everything that’s happened on your loan, newest first.</p>
          <ol className="relative mt-10 space-y-7 border-l border-ink-200 pl-8" data-id="element-1098" data-mp="2a6k4cavny4q0">
            {activity.map(a => <li key={a.id} className="relative" data-id="element-1099" data-mp="2f7pzefcsq42p">
                <span className={`absolute -left-[45px] grid h-7 w-7 place-items-center rounded-full ring-4 ring-canvas ${a.kind === 'accepted' ? 'bg-positive-50 text-positive-500' : a.kind === 'request' ? 'bg-caution-50 text-caution-700' : 'bg-pulse-50 text-pulse-600'}`} aria-hidden data-id="element-1100" data-mp="2175dvbfhxu5i">
                  {activityIcon[a.kind]}
                </span>
                <p className="text-[15px] font-medium text-ink-900" data-id="element-1101" data-mp="2xw4nouvqb3zt">{fill(a.title)}</p>
                <p className="mt-0.5 text-[13px] text-ink-400" data-id="element-1102" data-mp="2k4zwmh6ffk13">{a.time}</p>
              </li>)}
          </ol>
        </section>

        <section aria-labelledby="notif-title" data-id="element-1103" data-mp="3bwp81vhal7vf">
          <h2 id="notif-title" className="flex items-center gap-2 text-sm font-medium text-ink-900" data-id="element-1104" data-mp="3bvvy6ln1e292">
            <BellIcon className="h-4 w-4" aria-hidden data-id="element-1105" data-mp="3go790jjbf8ge" /> How we’ll reach you
          </h2>
          <p className="mt-1 text-sm text-ink-500" data-id="element-1106" data-mp="3qicujnaywohg">Every message links back to this page — no passwords, ever.</p>
          <div className="mt-5 rounded-[28px] bg-ink-100 p-4" data-id="element-1107" data-mp="3miarb9pl3n02">
            <ul className="space-y-4" data-id="element-1108" data-mp="3hi6hu3n3fsjc">
              {notificationPatterns.map(n => <li key={n.id} data-id="element-1109" data-mp="3cjv77qoz5e02">
                  <p className="mb-1.5 flex items-center gap-1.5 px-1 text-[11px] font-medium text-ink-500" data-id="element-1110" data-mp="3citl8r6f773k">
                    {n.channel.includes('Email') ? <MailIcon className="h-3 w-3" aria-hidden data-id="element-1111" data-mp="37md1082cdcvr" /> : <MessageSquareIcon className="h-3 w-3" aria-hidden data-id="element-1112" data-mp="32sqvczuli99g" />}
                    {n.trigger} · {n.channel}
                  </p>
                  <p className="rounded-2xl rounded-bl-md bg-white px-3.5 py-2.5 text-[14px] leading-snug text-ink-900 shadow-soft" data-id="element-1113" data-mp="2yq416sagcc93">{fill(n.body)}</p>
                </li>)}
            </ul>
          </div>
        </section>
      </main>
    </LoanShell>;
}